/**
 * Integration Status DTO enum - wire format for integration connection status
 * Represents the status of an individual integration provider
 */
export enum IntegrationStatusDTO {
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
  SYNCING = 'SYNCING',
  UNKNOWN = 'UNKNOWN',
}

/**
 * Type alias for request - makes intent clear
 */
export type IntegrationStatusRequest = IntegrationStatusDTO;

/**
 * Type alias for response - makes intent clear
 */
export type IntegrationStatusResponse = IntegrationStatusDTO;

/**
 * Organization Integration Status DTO enum - wire format for organization-wide integration status
 * Represents the overall status of all integrations in the organization
 */
export enum OrganizationIntegrationStatusDTO {
  IDLE = 'IDLE',
  SYNCING = 'SYNCING',
  SYNC_FAILED = 'SYNC_FAILED',
  HAS_CONFLICTS = 'HAS_CONFLICTS',
  UNKNOWN = 'UNKNOWN',
}

/**
 * Type alias for request - makes intent clear
 */
export type OrganizationIntegrationStatusRequest = OrganizationIntegrationStatusDTO;

/**
 * Type alias for response - makes intent clear
 */
export type OrganizationIntegrationStatusResponse = OrganizationIntegrationStatusDTO;
